import { PaymentType } from "../shared/models/payment-type-enum";

export class RegistrationsList {
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    playerRegistrationCode: string;
    teamCaptain: string;
    skins: boolean;
    startingHole: string;
    hasPaid: boolean;
    isCheckedIn: boolean;
    startDate: Date;
    paymentType: PaymentType;
    cost: number;
}
